export default __webpack_public_path__ + "static/media/eCheck-Color.79c0c4c1.svg";